<script lang="ts">
    let {
        onclick = () => {
        },
        active = false,
        content,
        children,
        disabled = false,
        size = 'md',
        class: className = '',
    }: {
        onclick?: () => void;
        active?: boolean;
        content?: string;
        children?: () => any;
        disabled?: boolean;
        size?: 'sm' | 'md' | 'lg';
        class?: string;
    } = $props();

</script>

{#if size === 'sm'}
    <button
            type="button"
            onclick={onclick}
            class="rounded-xl px-2 py-1.5 text-[10px] border font-bold transition-all {className}"
            {disabled}
            class:active
    >
        {#if children}
            {@render children?.()}
        {:else if content}
            {content}
        {/if}
    </button>
{:else if size === 'md'}
    <button
            type="button"
            onclick={onclick}
            class="rounded-xl border p-3 text-xs font-bold transition-all {className}"
            {disabled}
            class:active
    >
        {#if children}
            {@render children?.()}
        {:else if content}
            {content}
        {/if}
    </button>
{:else if size === 'lg'}
    <button
            type="button"
            onclick={onclick}
            class="rounded-2xl border p-4 text-sm font-bold transition-all {className}"
            {disabled}
            class:active
    >
        {#if children}
            {@render children?.()}
        {:else if content}
            {content}
        {/if}
    </button>
{/if}

<style>
    @import "tailwindcss";

    button {
        cursor: pointer;
        border: 1px solid #7C46AF;
    }

    button:disabled {
        cursor: not-allowed;
    }

    button.active {
        background-color: #7C46AF;
        color: white;
        box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.1), 0 2px 4px -1px rgba(37, 99, 235, 0.06);
    }

    button:not(.active) {
        border-color: #E5E7EB;
        background-color: white;
        color: #6B7280;
    }
</style>
